<script setup lang="ts">
import {CirclePlusFilled, RemoveFilled} from "@element-plus/icons-vue";

defineProps<{
  optionList: { option: string }[],
}>()

const emit = defineEmits(['on-option-add', "on-option-remove"])

const onAddOption = () => {
  emit("on-option-add")
}

const onRemoveOption = () => {
  emit("on-option-remove")
}
</script>

<template>
  <el-input v-for="(item, index) in optionList" v-model="item.option" class="mt-.5rem">
    <template #prepend>
      {{ String.fromCharCode(index + 65) }}
    </template>
  </el-input>
  <div class="flex mt-1rem">
    <el-button type="primary" :icon="CirclePlusFilled" @click="onAddOption">添加选项</el-button>
    <el-button type="danger" :icon="RemoveFilled" @click="onRemoveOption" v-if="optionList.length > 1">移除选项
    </el-button>
  </div>
</template>

<style scoped>
</style>
